import useAxiosAuthentication from "@/compositions/useAxiosAuthentication";
import axios, { type AxiosRequestConfig } from "axios";
import { DEFAULT_HEADERS } from "@/compositions/useAxios/data.ts";
import type { PartnerRelationship } from "@/store/partner-relationships/types";

const axiosInstance = axios.create();
useAxiosAuthentication(axiosInstance);

const getAll = async (config?: AxiosRequestConfig) => {
  const url = `${import.meta.env.VITE_API_TENANT_BASE_URL}/customer/parents`;
  let response = null;

  try {
    response = await axiosInstance.get<PartnerRelationship[]>(url, {
      ...config,
      headers: {
        ...config?.headers,
        ...DEFAULT_HEADERS,
        "api-key": import.meta.env.VITE_TENANT_API_KEY
      }
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export default { getAll };
